import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Page from '../Page.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import FormPartial from './FormPartial.js';
import Circle from '../../models/Circle.js';
import { getApi } from '../../api/endpoints.js';
import { toast } from 'react-toastify';

const New = () => {
  const navigate = useNavigate();
  const [circle, setCircle] = useState(new Circle());
  const [createApi] = getApi('createBranches');

  const createRecord = async (params) => {
    try {
      await createApi(params).unwrap();
      toast.success("Circle Created Successfully");
      navigate("/circles");
    } catch (error) {
      toast.error(error.data?.message || "Something went wrong !");
      let circleObj = new Circle(circle);
      circleObj.set_api_errors(error?.data?.data?.errors);
    }
  }

  const handleSubmitFunction = () => {
    try{
      createRecord(new Circle(circle).toApiJson());
    } catch(error){
      setCircle(new Circle(circle));
    }
  }

  const handleCancelFunction = () => {
    navigate('/circles');
  }

  return <Page
      uiPage={uiManager.getUiPage(PAGES.NewCirclePage.name)}
      breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Circle", url: '/circles' }, { label: "Add New Circle" }]}
      className={'new-circle-page'}
    >
      <PageContentWrapper contentHeading={"Create New Circle"}>
        <div className='m-3'>
          <div className='mb-4 col'>
            <form className="row g-3" autoComplete="off">
              <FormPartial circle={circle} setCircle={setCircle} />
              <div className='mb-4 col'>
                <div>
                  <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>
                    Back
                  </button>
                  <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>
                    Create
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </PageContentWrapper>
    </Page>
}

export default New;
